export default __webpack_public_path__ + "static/cardTabImg3-0bd70e880c56fb9edb974d3938691d4d.webp";